import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('payment-proc/index', {params});
    },
    paymentPaid(params) {
        return Service().post('payment-proc/payment-paid', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
}